import { render } from "./EventBox.vue?vue&type=template&id=591f4e58"
import script from "./EventBox.vue?vue&type=script&lang=true"
export * from "./EventBox.vue?vue&type=script&lang=true"

import "./EventBox.vue?vue&type=style&index=0&id=591f4e58&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__